import React from "react";
import {Button, Form, FormControl} from 'react-bootstrap'

const Search = ({searchItem}) => {
  return (
    <div className="p-2" style={{height:'max-content'}}>
        <Form className="d-flex" onSubmit={(e) => e.preventDefault()}>
            <FormControl
            type="search"
            placeholder="جستجوی محصول..."
            className="me-2 border-0 pe-2 ps-2 py-2"
            aria-label="Search"
            variant="outline-secondary"
            onChange={(event) => searchItem(event.target.value)}
            />
            <Button variant="outline-secondary" className="fa fa-search border-0 py-2"></Button>
        </Form>
    </div>
  );
}

export default Search;